import script from "./keyBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./keyBlock.vue?vue&type=script&setup=true&lang=ts"

import "./keyBlock.vue?vue&type=style&index=0&id=16cfa310&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16cfa310"]])

export default __exports__